var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/array.js
// module id = gb1M
// module chunks = 0